var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDydx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 71,
    viewBox: "0 0 227 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.223 0L161.34 70.366H176.348L225.485 0H210.223Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.911 0L192.294 20.7345L184.79 32.0442L162.59 0H177.911Z",
    fill: "url(#paint0_linear_3566_20484)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.681 70.3717L195.734 47.4381L203.239 36.4425L226.689 70.3717H211.681Z",
    fill: "url(#paint1_linear_3566_20484)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.83 0H156.963V70.366H143.83V67.7378C140.038 69.8175 135.683 71 131.053 71C116.351 71 104.434 59.0796 104.434 44.375C104.434 29.6704 116.351 17.75 131.053 17.75C135.683 17.75 140.038 18.9326 143.83 21.0122V0ZM130.913 59.3144C139.239 59.3144 145.989 52.563 145.989 44.2348C145.989 35.9065 139.239 29.1551 130.913 29.1551C122.586 29.1551 115.836 35.9065 115.836 44.2348C115.836 52.563 122.586 59.3144 130.913 59.3144Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.739 0L56.9062 70.366H72.2153L121.001 0H105.739Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2275 0L87.5485 21.3628L79.1063 33.3009L56.2812 0H72.2275Z",
    fill: "url(#paint2_linear_3566_20484)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3967 0H52.5289V70.366H39.3967V67.7378C35.6039 69.8175 31.2496 71 26.6192 71C11.9178 71 0 59.0796 0 44.375C0 29.6704 11.9178 17.75 26.6192 17.75C31.2496 17.75 35.6039 18.9326 39.3967 21.0122V0ZM26.479 59.3144C34.8055 59.3144 41.5554 52.563 41.5554 44.2348C41.5554 35.9065 34.8055 29.1551 26.479 29.1551C18.1526 29.1551 11.4027 35.9065 11.4027 44.2348C11.4027 52.563 18.1526 59.3144 26.479 59.3144Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3566_20484",
    x1: 174.471,
    y1: 4.39823,
    x2: 195.177,
    y2: 29.2763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3566_20484",
    x1: 215.12,
    y1: 65.031,
    x2: 189.668,
    y2: 30.8812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6966FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6966FF",
    stopOpacity: 0.36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3566_20484",
    x1: 68.7881,
    y1: 4.57071,
    x2: 90.2539,
    y2: 30.6952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDydx);
export default __webpack_public_path__ + "static/media/dydx.40b64cd2cbce4b6e66e1ae9b28b10a0d.svg";
export { ForwardRef as ReactComponent };